<template>
  <div id="app">
    <keep-alive>
      <!-- <yd-tabbar :fixed="true" :padding="'0.3rem'" :font-size="'0.3rem'">
        <yd-tabbar-item title="首页" link="/" acitve>
            <yd-icon name="Index" slot="icon"></yd-icon>
        </yd-tabbar-item>
        <yd-tabbar-item title="供应商" link="/supplierLogin" acitve>
            <yd-icon name="supplierLogin" slot="icon"></yd-icon>
        </yd-tabbar-item>
    </yd-tabbar> -->
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="isRouterAlive&&!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload,
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  },
  created() {
  },
  activated() {
    // 当引入keep-alive 的时候，页面第一次进入，钩子的触发顺序created-> mounted-> activated，
    // 退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated。
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue